/**
 * 图片空间入库上下文（类似 AOP 的 ThreadLocal）：当前工作台模块 / 工作流节点 / 入库类型。
 * 所有经 imageSpaceAPI.batchSave / imageStorageAPI.save 的写入可自动继承此上下文。
 */

const DEFAULT_CONTEXT = Object.freeze({
  navId: '',
  source: '',
  ingestKind: 'upload',
  workflowStepNavId: '',
});

let ambientContext = { ...DEFAULT_CONTEXT };
/** @type {Array<typeof DEFAULT_CONTEXT>} */
const contextStack = [];

function normalizePartial(partial = {}) {
  const next = { ...partial };
  if (next.navId != null) next.navId = String(next.navId).trim();
  if (next.source != null) next.source = String(next.source).trim();
  if (next.workflowStepNavId != null) {
    next.workflowStepNavId = String(next.workflowStepNavId).trim();
  }
  if (next.ingestKind !== 'result' && next.ingestKind !== 'upload') {
    next.ingestKind = 'upload';
  }
  return next;
}

export function getImageSpaceIngestContext() {
  if (contextStack.length > 0) {
    return contextStack[contextStack.length - 1];
  }
  return ambientContext;
}

/** 由工作台根组件同步当前导航（页面级默认上下文） */
export function setImageSpaceIngestContext(partial = {}) {
  ambientContext = { ...ambientContext, ...normalizePartial(partial) };
}

export function resetImageSpaceIngestContext() {
  ambientContext = { ...DEFAULT_CONTEXT };
  contextStack.length = 0;
}

/**
 * 在指定上下文中执行（支持同步 / Promise），用于工作流单步、详情保存结果等。
 * @param {Partial<typeof DEFAULT_CONTEXT>} partial
 * @param {() => T} fn
 * @returns {T}
 */
export function runWithImageSpaceIngestContext(partial, fn) {
  contextStack.push({ ...getImageSpaceIngestContext(), ...normalizePartial(partial) });
  try {
    const result = fn();
    if (result && typeof result.then === 'function') {
      return result.finally(() => {
        contextStack.pop();
      });
    }
    contextStack.pop();
    return result;
  } catch (error) {
    contextStack.pop();
    throw error;
  }
}

export async function runWithImageSpaceIngestContextAsync(partial, fn) {
  contextStack.push({ ...getImageSpaceIngestContext(), ...normalizePartial(partial) });
  try {
    return await fn();
  } finally {
    contextStack.pop();
  }
}
